import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';
import { Colors, MediaBreakPointUp } from '@lean-body/components/styles';
export const MatchingAssessmentDescription = ({ title, description, classObject, }) => {
    return (React.createElement("section", null,
        React.createElement("div", { className: css(styles.container, classObject) },
            React.createElement("span", { className: css(styles.title) }, title),
            React.createElement("span", { className: css(styles.description) }, description))));
};
const styles = StyleSheet.create({
    container: {
        position: 'relative',
        width: '100vw',
        whiteSpace: 'pre-wrap',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        [MediaBreakPointUp.MD]: {
            width: 800,
        },
    },
    title: {
        fontSize: 22,
        fontWeight: 'bold',
        marginBottom: 14,
    },
    description: {
        fontSize: 14,
        fontWeight: 500,
        color: Colors.GrayDarkest,
        marginBottom: 16,
    },
});
